import {Component, OnInit, ViewChild} from '@angular/core';
import {SnotifyService} from 'ng-snotify';
import {MStore} from './model/m-store';
import {MStoreService} from './service/m-store.service';
import {MBranchService} from '../../service/m-branch/service/m-branch.service';
import {MBranch} from '../../service/m-branch/model/m-branch';
import {Observable} from '../../../../../node_modules/rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';
import {AppSettings} from '../../settings/app-settings';

@Component({
  selector: 'app-m-store',
  templateUrl: './m-store.component.html'
})
export class MStoreComponent implements OnInit {

  private mStores: MStore [] = [];
  private mBranchs: MBranch [] = [];
  private filter: string;
  private mStore: MStore;
  private uiMode: string;
  @ViewChild('inputForm') inputForm;

  constructor(private mStoreService: MStoreService,
              private snotifyService: SnotifyService,
              private mBranchService: MBranchService) {
    this.mStore = new MStore();
  }

  ngOnInit() {
    this.uiMode = 'IDEAL';
    this.loadMStores();
    this.loadMBranch();
  }

  sumbmitFormData(): void {
    if (this.inputForm.invalid) {
      this.snotifyService.error('Fill All Input Text', AppSettings.MESSAGE_WARNING, {
        timeout: 2000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true
      });
    } else {
      this.snotifyService.confirm('Save ?..', AppSettings.MESSAGE_INFO, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: false,
        pauseOnHover: false,
        buttons: [
          {
            text: 'Yes', action: (toast) => {
              this.snotifyService.remove(toast.id);
              this.mStoreService.save(this.mStore).subscribe((mGiftVoucherPriceCategorys) => {
                this.mStores.push(mGiftVoucherPriceCategorys);
                this.snotifyService.success('Store Save Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              }, (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
            }
          },
          {
            text: 'No', action: (toast) => {
              this.snotifyService.remove(toast.id);
            }, bold: true
          },
        ]
      });
    }
  }

  selectFormData(rowNo, mStore: MStore) {
    this.uiMode = 'SELECTED';
    this.mStore = mStore;
    this.mStores.splice(rowNo, 1);
  }

  newFormData(): void {
    this.uiMode = 'EDIT';
  }

  clearFormData(): void {
    this.inputForm.reset();
    this.uiMode = 'IDEAL';
    this.loadMStores();
    this.loadMBranch();
  }

  deleteFormData(): void {
    this.snotifyService.confirm('Delete ?..', AppSettings.MESSAGE_WARNING, {
      timeout: 5000,
      showProgressBar: false,
      closeOnClick: false,
      pauseOnHover: false,
      buttons: [
        {
          text: 'Yes', action: (toast) => {
            this.snotifyService.remove(toast.id);
            this.mStoreService.delete(this.mStore.indexNo).subscribe((data) => {
                this.snotifyService.success('Store Delete Success!', AppSettings.MESSAGE_SUCCESS, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
                this.clearFormData();
              },
              (e) => {
                this.snotifyService.error(e.error.message, AppSettings.MESSAGE_ERROR, {
                  timeout: 2000,
                  showProgressBar: false,
                  closeOnClick: false,
                  pauseOnHover: true
                });
              });
          }
        },
        {
          text: 'No', action: (toast) => {
            this.snotifyService.remove(toast.id);
          }, bold: true
        },
      ]
    });
  }

  formatterMBranch = (x: { name: string }) => x.name;
  searchMBranch = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term === '' ? []
        : this.mBranchs.filter(v => v.name.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  loadMStores(): void {
    this.mStoreService.findAll().subscribe((mGiftVoucherPriceCategorys) => {
        this.mStores = mGiftVoucherPriceCategorys;
      },
      (e) => {
        this.mStores = [];
      });
  }

  loadMBranch(): void {
    this.mBranchService.findByType('MAIN').subscribe((data) => {
      this.mBranchs = data;
    }, (e) => {
      this.mBranchs = [];
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-store/m-store.component.ts